import { gql } from "@apollo/client";

import calibrationNodeFragment from "./calibration-node-fragment";

export default gql`
  ${calibrationNodeFragment}
  query getAllPrecalibrations($complianceProgramId: Int!, $templateId: Int!) {
    assessmentCalibrations(
      complianceProgramId: $complianceProgramId
      templateId: $templateId
      isPrecalibration: true
    ) {
      edges {
        node {
          ...CalibrationNode
        }
      }
    }
  }
`;
